import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPlayer from 'react-player'
import { useDisableBodyScroll } from "../../../hooks/useDisableBodyScroll";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { hideShowAnswers, toggleModal, toggleShowAnswers, updateIsMobile } from "../../../redux/slices/preview";
import { selectUserActivity } from "../../../redux/slices/userActivity";
import ActivityBox from "../../designActivity/activity/activityBox";

import "./preview.css";
import ShowAnswers from "./showAnswers";
import { useCallback } from "react";
import { useRef } from "react";
import PrevIcon from '../../../assets/icons/video-prev.svg'
import NextIcon from '../../../assets/icons/video-next.svg'
import RefreshIcon from '../../../assets/icons/refresh.svg'
import Video from "./Video";
import { getTime } from "../../../utils";

export default function Preview() {
  const dispatch = useDispatch();
  const { userActivities, videoDuration, selectedUserActivity, isVideo, videoVisible } = useSelector((state) => state.userActivity);
  const { modalOpen, showAnswers, isMobile } = useSelector((state) => state.preview);
  const { title, video, video_url } = useSelector((state) => state.duonutSettings.settings);
  const { width } = useWindowDimensions();
  const playerRef = useRef(null)
  const [videoPlaying, setVideoPlaying] = useState(false)
  const [progress, setProgress] = useState(0)
  const [isPlayed, setIsPlayed] = useState(false)
  const [source, setSource] = useState('')

  const handleClose = () => {
    dispatch(toggleModal());
    showAnswers && dispatch(toggleShowAnswers());
  };

  useDisableBodyScroll(modalOpen);

  const selectActivity = (idx) => {
    dispatch(hideShowAnswers());
    dispatch(selectUserActivity(idx));
  };

  const selectPrevActivity = () => {
    if (selectedUserActivity <= 0) return;
    dispatch(selectUserActivity(selectedUserActivity - 1));
  };
  const selectNextActivity = () => {
    if (selectedUserActivity >= userActivities.length - 1) return;
    dispatch(selectUserActivity(selectedUserActivity + 1));
  };

  useEffect(() => {
    return () => {
      // if (modalOpen === false) {
      if (width <= 768) {
        // console.log('dont run 1', modalOpen);
        dispatch(updateIsMobile(true))
      } else {
        // console.log('dont run 2', modalOpen);
        dispatch(updateIsMobile(false))
      }
    }
    // }
  }, []);

  //pre video
  let intervalId = null
  useEffect(() => {
    // selectActivity(0)
    if (videoPlaying === true) return
    if (isPlayed) return
    let intFunc = () => {
      console.log('selectedUserActivity', selectedUserActivity);
      if (userActivities[selectedUserActivity + 1]?.question_id?.timestamp === 0) {
        setVideoPlaying(false)
        if (userActivities[selectedUserActivity + 1] === undefined) return
        selectActivity(selectedUserActivity + 1)
      } else {
        setVideoPlaying(true)
      }
    }
    intervalId = setInterval(intFunc, 8000);
    return () => clearInterval(intervalId, intFunc)
  }, [userActivities, selectedUserActivity, videoPlaying, isPlayed])

  //post video
  let intervalId3 = null
  useEffect(() => {
    // selectActivity(0)
    if (isPlayed === false) return
    let intFunc = () => {
      // console.log('selectedUserActivity', selectedUserActivity);
      if (userActivities[selectedUserActivity + 1]?.question_id?.timestamp === -1) {
        setVideoPlaying(false)
        if (userActivities[selectedUserActivity + 1] === undefined) return
        selectActivity(selectedUserActivity + 1)
      }
    }
    intervalId3 = setInterval(intFunc, 8000);
    return () => clearInterval(intervalId3, intFunc)
  }, [userActivities, selectedUserActivity, videoPlaying])

  //when playing
  let intervalId2 = null
  let playingVideoTimeoutId = null
  useEffect(() => {
    let intFunc = () => {
      if (videoPlaying === false) return
      if (isPlayed) return
      // console.log('next act', userActivities[selectedUserActivity + 1]?.question_id);
      if (userActivities[selectedUserActivity + 1] === undefined) return
      // console.log(progress, userActivities[selectedUserActivity + 1].question_id.timestamp);
      if (userActivities[selectedUserActivity + 1]?.question_id?.timestamp === -1) return

      if (progress > userActivities[selectedUserActivity + 1].question_id.timestamp) {
        selectActivity(selectedUserActivity + 1)
        setVideoPlaying(false)
        playingVideoTimeoutId = setTimeout(() => {
          setVideoPlaying(true)
        }, 10000);
      }
    }
    // intervalId2 = setInterval(intFunc, 3000);
    intFunc()
    return () => clearInterval(intervalId2, intFunc)
  }, [videoPlaying, userActivities, selectedUserActivity, progress, isPlayed])

  const onProgress = useCallback((res) => {
    setProgress(res.playedSeconds)
  }, [])

  useEffect(() => {
    if (progress >= videoDuration) {
      setIsPlayed(true)
      setVideoPlaying(false)
    }
  }, [progress, videoDuration])
  // console.log('progress', progress);
  // console.log('videoDuration', videoDuration);
  // console.log('selectedUserActivity', selectedUserActivity);

  const handleDeviceChange = (bool) => {
    dispatch(updateIsMobile(bool))
  };

  const handlePrev = () => {
    clearTimeout(playingVideoTimeoutId)
    const seekAmount = userActivities[selectedUserActivity - 1]?.question_id?.timestamp
    console.log('prev act', seekAmount);
    if (seekAmount === undefined) return
    selectActivity(selectedUserActivity - 1)
    if (seekAmount > 0) {
      playerRef.current.seekTo(seekAmount, 'seconds')
      setVideoPlaying(true)
    } else if (seekAmount === 0) {
      playerRef.current.seekTo(0, 'seconds')
      setVideoPlaying(false)
    } else if (seekAmount === -1) {
      playerRef.current.seekTo(videoDuration, 'seconds')
      setVideoPlaying(false)
    }
  }

  const handleNext = () => {
    clearTimeout(playingVideoTimeoutId)
    const seekAmount = userActivities[selectedUserActivity + 1]?.question_id?.timestamp
    console.log('next act', seekAmount);
    if (seekAmount === undefined) return
    selectActivity(selectedUserActivity + 1)
    if (seekAmount > 0) {
      playerRef.current.seekTo(seekAmount, 'seconds')
      setVideoPlaying(true)
    } else if (seekAmount === 0) {
      playerRef.current.seekTo(0, 'seconds')
      setVideoPlaying(false)
    } else if (seekAmount === -1) {
      playerRef.current.seekTo(videoDuration, 'seconds')
      setVideoPlaying(false)
    }
  }

  const handleRestart = () => {
    setIsPlayed(false)
    setProgress(0)
    setVideoPlaying(false)
    dispatch(selectUserActivity(0));
    playerRef?.current.seekTo(0, 'seconds')
  }

  useEffect(() => {
    if (video_url) {
      setSource(video_url)
    } else if (typeof video === 'string') {
      setSource(video)
    } else {
      if (video) {
        setSource(URL.createObjectURL(video))
      }
    }
  }, [video_url, video])

  // console.log('activity', userActivities[selectedUserActivity]);
  return (
    <div className="modal_container modal-container-preview">
      <div style={{ overflow: 'auto', width: '100%', alignSelf: 'stretch' }}>

        <div className="preview_modal">
          <div className="title">
            <h4> {title ? title : "Title"} </h4>
            <div className="showan">
              <ShowAnswers showAnswers={showAnswers} />
            </div>
          </div>

          {width >= 1200 &&
            <>
              {
                isVideo ?
                  <div className="flex items-center" >
                    <Video videoPlaying={videoPlaying} video={video} onProgress={onProgress} playerRef={playerRef} video_url={video_url} source={source} />
                    {Object.keys(userActivities[selectedUserActivity]).length > 1 && <ActivityBox master={userActivities[selectedUserActivity]} />}
                  </div>
                  :
                  Object.keys(userActivities[selectedUserActivity]).length > 1 && <ActivityBox master={userActivities[selectedUserActivity]} />
              }
            </>
          }
          {width < 1200 &&
            <>
              <div className={`flex items-center ${!videoPlaying ? 'hidden' : ''} `} >

                <Video videoPlaying={videoPlaying} video={video} onProgress={onProgress} playerRef={playerRef} video_url={video_url} />
                {/* {Object.keys(userActivities[selectedUserActivity]).length > 1 &&
                  <ActivityBox master={userActivities[selectedUserActivity]} />} */}

              </div>

              <div className={`${!videoPlaying ? '' : 'hidden'}`}>
                {Object.keys(userActivities[selectedUserActivity]).length > 1 && <ActivityBox master={userActivities[selectedUserActivity]} />}
              </div>

            </>
          }


          <footer>
            <div className="paginationdiv">
              <div className="title1">
                <ShowAnswers showAnswers={showAnswers} />
              </div>
              {
                isVideo ?
                  <div className="preview_pagination_control">
                    <img src={PrevIcon} alt='prev' onClick={handlePrev} />
                    <div className="pagination_control_text">
                      {selectedUserActivity + 1}/{userActivities.length}
                    </div>
                    <img src={NextIcon} alt='prev' onClick={handleNext} />
                    <img src={RefreshIcon} alt='prev' className="refresh-icon" onClick={handleRestart} />
                  </div> :
                  <div className="preview_pagination_control">
                    <button className="pagination_control_button preview_prev_slide_btn icon-button" onClick={selectPrevActivity} disabled={selectedUserActivity === 0}>
                      <svg width={10} height={18} viewBox="0 0 18 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.2811 31.2601C18.2396 30.2735 18.2396 28.6739 17.2811 27.6873L5.9258 16L17.2811 4.31269C18.2396 3.32611 18.2396 1.72653 17.2811 0.739943C16.3225 -0.246647 14.7684 -0.246647 13.8098 0.739943L0.71892 14.2136C-0.23964 15.2002 -0.23964 16.7998 0.71892 17.7864L13.8098 31.2601C14.7684 32.2466 16.3225 32.2466 17.2811 31.2601Z"
                          fill="white"
                        />
                      </svg>
                    </button>

                    <div className="pagination_control_text">
                      {selectedUserActivity + 1}/{userActivities.length}
                    </div>

                    <button className="pagination_control_button preview_next_slide_btn icon-button" onClick={selectNextActivity} disabled={selectedUserActivity === userActivities.length - 1}>
                      <svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.583619 0.861432C1.09485 0.335252 1.92372 0.335252 2.43495 0.861432L9.41677 8.0474C9.928 8.57358 9.928 9.42668 9.41677 9.95286L2.43495 17.1388C1.92372 17.665 1.09485 17.665 0.583619 17.1388C0.0723874 16.6126 0.0723874 15.7595 0.583619 15.2334L6.63977 9.00013L0.583619 2.7669C0.0723874 2.24072 0.0723874 1.38761 0.583619 0.861432Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
              }
            </div>
            <div
              className="preview_pagination"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            // id={slidesActive && 'slides-active'}
            >
              <div style={{ flex: '1', overflow: 'auto' }} >

                <div
                  className="pagination_activities"
                  style={{ width: "100%", flex: '1' }}
                >
                  {
                    isVideo ?
                      userActivities.map((activity, i) => {
                        let timer = activity?.question_id?.timestamp === -1 ? -1 : getTime(activity?.question_id?.timestamp)
                        // console.log('activity', activity);
                        return (
                          <div key={i} className="activity pagination-activity" onClick={() => selectActivity(i)}>
                            <div className="activity_number"> {i + 1} </div>
                            <div className={`activity_image_box ${selectedUserActivity === i ? "active" : ""}`}>
                              {activity.theme_id &&
                                <img src={activity.theme_id.thumbnail ? activity.theme_id.thumbnail : activity.theme_id.thumbnail_data.uri} alt="thumbnail" />}
                            </div>
                            <div className="pagination-timer">
                              {
                                timer.minutes === 0 && timer.seconds === 0 ?
                                  <p className="pre-video">
                                    Pre video
                                  </p>
                                  : timer === -1 ?
                                    <p className="pre-video">
                                      Post video
                                    </p> :
                                    <p className="on-video">
                                      {`${timer.minutes > 9 ? timer.minutes : `0${timer.minutes}`}:${timer.seconds > 9 ? timer.seconds : `0${timer.seconds}`}`}
                                    </p>

                              }
                            </div>
                          </div>
                        );
                      })
                      :
                      userActivities.map((activity, i) => {
                        return (
                          <div key={i} className="activity" onClick={() => selectActivity(i)}>
                            <div className="activity_number"> {i + 1} </div>
                            <div className={`activity_image_box ${selectedUserActivity === i ? "active" : ""}`}>
                              {activity.theme_id &&
                                <img src={activity.theme_id.thumbnail ? activity.theme_id.thumbnail : activity.theme_id.thumbnail_data.uri} alt="thumbnail" />}
                            </div>
                          </div>
                        );
                      })

                  }
                  {/* <img src="/assets/icons/add-activity.svg" className="add-activity-icon" /> */}

                </div>
              </div>

              <div className="device_select">
                <p>Select Device :</p>
                <div className="device_icons">
                  <div className={`${!isMobile ? 'selected' : ''}`} onClick={() => handleDeviceChange(false)}>
                    <img src='/assets/icons/desktop.svg' />
                  </div>
                  <div className={`${isMobile ? 'selected' : ''}`} onClick={() => handleDeviceChange(true)}>
                    <img src='/assets/icons/phone.svg' />
                  </div>
                  {/* <div>
                  <img src='/assets/icons/tablet.svg' />
                </div> */}
                </div>
                {/* <p style={{ padding: '2px 6px' }} onClick={() => handleDeviceChange(true)} >mobile</p>
              <p style={{ padding: '2px 6px' }} onClick={() => handleDeviceChange(false)} >desktop</p>
              <p style={{ padding: '2px 6px' }} onClick={() => handleDeviceChange(false)} >tablet</p> */}
              </div>
            </div>
          </footer>
          <div className="close-icon icon-button" onClick={handleClose} style={{ display: "flex" }}>
            <img src="/assets/icons/close-white.svg" alt="close" />
          </div>
        </div>

      </div>
    </div>
  );
}
